query getWalletFundsAddresses($eth_address: String!, $type: String!, $balances: Boolean!) {
    getWalletFundsAddresses(eth_address: $eth_address, type: $type, balances: $balances)
}